import { AccountCircleOutlined, Add, AddOutlined, ArrowBack, ArrowBackOutlined, ArrowLeft, ArrowLeftOutlined, ArrowRightAlt, AutoAwesome, AutoAwesomeOutlined, AutoModeOutlined, Delete, DeleteOutline, Description, DownloadOutlined, Edit, EditOutlined, FilterAltOffOutlined, FilterAltOutlined, FolderOutlined, FolderSpecialOutlined, Home, HomeOutlined, KeyboardDoubleArrowLeft, MenuOpen, MoreHoriz, UploadOutlined } from '@mui/icons-material';
import { Avatar, Box, Breadcrumbs, Button, Chip, CircularProgress, Divider, Fab, Icon, IconButton, Skeleton, Tab, Tabs, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material'
import { useApplicationContext } from '../../../context/ApplicationContext';
import { useEffect, useState } from 'react';
import { blue, grey, purple, red } from '@mui/material/colors';
import { font } from '../../../styles/font';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ChatWindow from '../ChatWindow';
import ProjectViewContainer from './ActiveProjectContainer';
import GridViewIcon from '@mui/icons-material/GridView';
import ListIcon from '@mui/icons-material/List';
import Treeview from '../../common/Treeview';
import { LightTooltip } from '../../styled/CustomComponent';
import SidebarToggleButton from '../../common/SidebarToggleButton';
import ChatWindowToggleButton from '../../common/ChatWindowToggleButton';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import ActiveProjectContainer from './ActiveProjectContainer';
import CreateModuleDialog from '../../dialog/CreateModuleDialog';
import { HttpStatusCode } from 'axios';
import { FolderType, ModulePath, Severity } from '../../../constant/ApplicationVariables';
import useErrorHandler from '../../../api/errorHandler/useErrorHandler';
import { addModule_API, deleteModule_API, updateModule_API } from '../../../api/controller/ModuleController';
import { getFolderStructureList_API } from '../../../api/controller/RequirementController';
import EditModuleDialog from '../../dialog/EditModuleDialog';
import DeleteModuleDialog from '../../dialog/DeleteModuleDialog';

export default function ActiveProject() {
    const {
        toggleChatWindow, setToggleChatWindow,
        toggleFolderSidebar, setToggleFolderSidebar,
        folderStructureList, setFolderStructureList,
        activeProject, setActiveProject,
        handleSnackbar,
        currentFolderData, setCurrentFolderData,
        isUpdateCurrentFolderData, setIsUpdateCurrentFolderData,
        isUpdateFolderStructure, setIsUpdateFolderStructure,
        openCreateStoryDialog, setOpenCreateStoryDialog,
        openEditStoryDialog,
        openCreateUseCaseDialog, setOpenCreateUseCaseDialog,
        openEditUseCaseDialog, setOpenEditUseCaseDialog,
        isGridViewEnabled, setIsGridViewEnabled,
    } = useApplicationContext();
    const theme = useTheme();
    const errorHandler = useErrorHandler();
    const pathName = useLocation()?.pathname;

    const [loading, setLoading] = useState(false);
    const [openCreateModuleDialog, setOpenCreateModuleDialog] = useState(false);
    const [openEditModuleDialog, setOpenEditModuleDialog] = useState(false);
    const [openDeleteModuleDialog, setOpenDeleteModuleDialog] = useState(false);

    // console.log(folderStructureList, "folderStructureList");

    
    return (
        <Box className=" flex gap-0 relative h-full w-full box-border  overflow-hidden ">

            {/* main container */}
            <Box
                className="flex flex-col gap-4 h-full relative overflow-hidden z-20 "
                bgcolor={theme.palette.primary.layout_col}
                sx={{
                    // width: (toggleFolderSidebar && toggleChatWindow) ? "50vw" : (toggleFolderSidebar && !toggleChatWindow) ? "80vw" : "70vw",
                    width : "100%",
                    transition: "width 0.5s ease-in-out",
                    // maxHeight: isGridViewEnabled ? "96.5%" : "unset",
                    boxSizing: "border-box"
                }}
            >

                <Box className={`flex flex-col h-full w-full   `}>
                    <ActiveProjectContainer />
                </Box>


            </Box>



        </Box>
    )
}